import { useState, useEffect } from 'react';
import { newsletterService } from '../services/apiService';
import NewsletterList from '../components/NewsletterList';

const GloballySmart = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const LIMIT = 10;

  const fetchNewsletters = async (pageNumber = page) => {
    try {
      setLoading(true);
      const response = await newsletterService.getNewslettersByType('globally-smart', { page: pageNumber, limit: LIMIT });
      if (response && response.data) {
        setNewsletters(response.data || []);
        setTotalPages(response.pagination?.total || 1);
      } else if (Array.isArray(response)) {
        setNewsletters(response);
        setTotalPages(1);
      }
      setError('');
    } catch (err) {
      setError(err.message || 'Failed to fetch newsletters');
      setNewsletters([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewsletters(page);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  if (loading) {
    return <div className="text-center py-8">Loading newsletters...</div>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-medium text-gray-800 mb-6">Globally Smart Newsletters</h1>
      {error ? (
        <div className="text-center py-8 text-red-500">{error}</div>
      ) : (
        <NewsletterList 
          newsletters={newsletters} 
          type="globally-smart" 
          title="Globally Smart Newsletters" 
          fetchNewsletters={fetchNewsletters} 
        />
      )}
      <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-600">Page {page} of {totalPages}</div>
        <div className="space-x-2">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className={`px-3 py-1 rounded bg-white border ${page === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}>
            Prev
          </button>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className={`px-3 py-1 rounded bg-white border ${page === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default GloballySmart;